import React from "react";
import {
  Row,
  Col,
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  UncontrolledTooltip,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { RenderRadioButton, RenderLabel } from "../../components";
import audienceTypeOptions from "../../helpers/audienceTypeFilterOptions";
import { Field } from "formik";
import { showTooltip } from "../../actions";

const AudienceTypeFilter = (props) => {
  const { t } = useTranslation();
  return (
    <ButtonDropdown
      className="col-12 col-sm-6 col-md-4 col-lg-2 third"
      isOpen={props.state.filters.audienceType}
      toggle={() => props.toggleFilter("audienceType")}
    >
      <DropdownToggle caret className="btn btn-default btn-dropdown-white">
        {t("discovery.filters.audience_type.title")}
      </DropdownToggle>
      <DropdownMenu className="ddmenu-col custom-dropdown-column width-md">
        <Row>
          <Col md="12" className="col">
            <span className="tooltip-button-wrap">
              <span className="text-tooltip">
                <h3 className="head icon-audience">
                  {t("discovery.audience")}
                </h3>
              </span>
              <span
                id="audienceTypeAudience"
                className="tooltip-icon tool-top"
              ></span>
            </span>
            {props.tooltip && (
              <UncontrolledTooltip
                className="tooltip-content"
                target="audienceTypeAudience"
              >
                {showTooltip("audienceTypeAudience")}
              </UncontrolledTooltip>
            )}
            <ul className="list-inline gender-list">
              {(audienceTypeOptions || []).map((option, index) => (
                <li key={index}>
                  <FormGroup check>
                    <RenderLabel check className="radio-container">
                      {option.text}
                      <Field
                        name="audienceType"
                        component={RenderRadioButton}
                        value={option.value}
                        checked={props.state.audienceType === option.value}
                        onChange={(input) =>
                          props.handleRadioButtonChange(
                            input,
                            "audienceType",
                            option.text
                          )
                        }
                      />
                      <span className="checkmark"></span>
                    </RenderLabel>
                  </FormGroup>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </DropdownMenu>
    </ButtonDropdown>
  );
};
export default AudienceTypeFilter;
